module.exports = __webpack_public_path__ + "img/SMA.583d1d32.png";